import { setCtn } from "../../../../../store/callbackRequest/slice";
import { setPopupVisibility } from "../../../OrderTariffFormOldPopup/store/actions/common";
import { resetInlineStepsData } from "../slice";
export var resetOrderTariffData = function resetOrderTariffData() {
  return function (dispatch) {
    dispatch(setPopupVisibility());
    dispatch(resetInlineStepsData());
    dispatch(setCtn(''));
  };
};